import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import notfound from 'assets/img/notfound.png';

type NotFoundProps = {
  message?: string;
};

const NotFound = ({ message }: NotFoundProps) => {
  return (
    <StyledWrapperBox>
      <StyledErrorBox>
        <Typography variant="h1">Pagina niet gevonden</Typography>
        <NotFoundImage src={notfound} alt="Page Not Found" />
        {message ? <Typography variant="body1">{message}</Typography> : null}
      </StyledErrorBox>
    </StyledWrapperBox>
  );
};

const StyledWrapperBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
}));

const StyledErrorBox = styled(Box)(({ theme }) => ({
  postion: 'relative',
  width: '33vw',
  maxWidth: '450px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  alignSelf: 'center',
  textAlign: 'center',
  padding: theme.spacing(2),
}));

const NotFoundImage = styled('img')(({ theme }) => ({
  margin: theme.spacing(2),
}));

export { NotFound };
